module.exports = __webpack_public_path__ + "assets/Feedback-dark.9ac39d35.svg";